import { NetworkStatus } from '@apollo/client';
import { Combobox, TextFieldAppearance, TextFieldSize } from '@bechtel/gds';
import { useDebounce } from '@bechtel/ht-clients-common';
import { OperatorType } from '@bechtel/ht-types';
import { get } from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useSearchToolInventories } from '~/hooks/use-search-tool-inventories';
import { SearchAreaStyled } from '../../list/styled';
import { ReturnToolDetailHeader } from '../styled';
import SearchToolInventoryItem from './search-tool-inventory-item';

const SearchToolByNameBarCode: FC = () => {
  const { searchToolInventories, data, loading, networkStatus } = useSearchToolInventories();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [searchText, setSearchText] = useState('');

  const updateSearchText = (e: any) => {
    setSearchText(e.target.value);
  };

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    if (searchText.length <= 3) {
      return;
    }

    searchToolInventories({
      sortInput: [],
      filterInput: {
        or: [
          {
            field: 'description',
            operator: OperatorType.LIKE,
            value: searchText,
          },
          {
            field: 'barCode',
            operator: OperatorType.LIKE,
            value: searchText,
          },
        ],
      },
      paginationInput: {
        offset: 0,
        limit: 20, // will chnage in future
      },
    });
  }, [debouncedSearchText, searchToolInventories]);

  const list = get(data, 'searchToolInventories.items', []);

  return (
    <ReturnToolDetailHeader>
      <SearchAreaStyled>
        <Combobox
          placeholder="Search Tools by name or barcode..."
          size={TextFieldSize.LARGE}
          items={list}
          appearance={TextFieldAppearance.NORMAL}
          itemComponent={SearchToolInventoryItem}
          selectedComponent={SearchToolInventoryItem}
          selectedItem={searchText}
          onSelect={(selectedItem: any) => {
            setSelectedItem(selectedItem);
          }}
          term={searchText}
          setTerm={setSearchText}
          handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            updateSearchText(event);
          }}
          restorePreviousOnSkip
          loading={loading || networkStatus === NetworkStatus.refetch}
          messageOnNoResults={`No inventory items found`}
        />
      </SearchAreaStyled>
    </ReturnToolDetailHeader>
  );
};

export default SearchToolByNameBarCode;
